export default "__VITE_ASSET__ff546457__"